module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [(_vm.localStorage.roles.includes('OnlineDirector') ||
    _vm.localStorage.roles.includes('OnlineReelReviewer') ||
    _vm.localStorage.roles.includes('CampusDirector') && _vm.terms) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'finalProjects' ? _vm.showPanel = null : _vm.showPanel = 'finalProjects'
      }
    }
  }, [_vm._v("Final Projects\n                "), (_vm.showPanel === 'finalProjects') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'finalProjects') ? _c('div', {
    staticClass: "panel-body nopad"
  }, [_c('final-projects')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('OnlineDirector') && _vm.allGroups && _vm.terms && _vm.academicPaths && _vm.supervisors) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'statistics' ? _vm.showPanel = null : _vm.showPanel = 'statistics'
      }
    }
  }, [_vm._v("\n                Group Statistics\n                "), (_vm.showPanel === 'statistics') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanel === 'statistics'),
      expression: "showPanel==='statistics'"
    }],
    staticClass: "panel-body row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroup),
      expression: "selectedGroup"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.allGroups), function(group) {
    return (group.students.length > 0 && group.groupTerm.type === 'foundation') ? _c('option', {
      domProps: {
        "value": group
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.termName(group.groupTerm.id)) + " — Group " + _vm._s(group.label) + " — " + _vm._s(_vm.supervisorName(group.id)) + "\n                        ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.allGroups), function(group) {
    return (group.students.length > 0 && group.groupTerm.type !== 'foundation') ? _c('option', {
      domProps: {
        "value": group
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.pathName(group.students[0].path)) + " — " + _vm._s(_vm.termName(group.groupTerm.id)) + " — Group " + _vm._s(group.label) + " — " + _vm._s(_vm.supervisorName(group.id)) + "\n                        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.selectedGroup) ? _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'groupStatistics',
        params: {
          groupId: _vm.selectedGroup.id,
          groupLabel: _vm.selectedGroup.label,
          term: _vm.selectedGroup.groupTerm.id
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("View group statistics for Group " + _vm._s(_vm.selectedGroup.label))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.selectedGroup.students) ? _c('ul', _vm._l((_vm.selectedGroup.students), function(student) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'student',
          params: {
            studentId: student.populiId
          },
          query: {
            userId: student.id,
            term: _vm.selectedGroup.groupTerm.id
          }
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(student.firstName) + " " + _vm._s(student.lastName) + "\n                                ")])], 1)
  })) : _vm._e()])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (
    (
      _vm.localStorage.roles.includes('Admin') ||
      _vm.localStorage.roles.includes('OnlineDirector') ||
      _vm.localStorage.roles.includes('CourseAdmin')
    ) &&
    _vm.courses &&
    _vm.academicTerms) ? _c('div', {
    staticClass: "panel courses nopad"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'courseAdmin' ? _vm.showPanel = null : _vm.showPanel = 'courseAdmin'
      }
    }
  }, [_vm._v("Course Admin\n                "), (_vm.showPanel === 'courseAdmin') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanel === 'courseAdmin'),
      expression: "showPanel==='courseAdmin'"
    }],
    staticClass: "panel-body nopad course-admin nice-scrollbar"
  }, [((_vm.localStorage.roles.includes('Faculty'))) ? _c('my-lessons', {
    attrs: {
      "courses": _vm.courses
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Edit your courses below:")]), _vm._v(" "), _vm._l((_vm.academicTerms), function(term) {
    return (_vm.hasTerm(term.id)) ? _c('div', {
      staticClass: "term"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          _vm.selectedTerm === term.id ? _vm.selectedTerm = null : _vm.selectedTerm = term.id
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.getTermName(term.id)) + "\n                                "), (_vm.selectedTerm === term.id) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedTerm === term.id),
        expression: "selectedTerm === term.id"
      }],
      staticClass: "panel-body"
    }, _vm._l((term.courses), function(instances, pathId) {
      return _c('ul', {
        staticClass: "instances"
      }, [_c('h3', [_vm._v(_vm._s(_vm.getPathNameFromId(pathId))), _c('label', [_vm._v("Order")])]), _vm._v(" "), _vm._l((instances), function(instance) {
        return _c('li', [_c('h4', [_c('router-link', {
          attrs: {
            "to": {
              name: 'courseAdmin',
              params: {
                instanceId: instance.id,
                courseId: instance.course
              },
              query: {
                term_name: _vm.getTermName(instance.term),
                path_name: _vm.getPathName(instance) || 'Foundation'
              }
            },
            "target": "_blank"
          }
        }, [(instance.associated.image) ? _c('img', {
          attrs: {
            "src": instance.associated.image
          }
        }) : _c('img', {
          attrs: {
            "src": require("./../assets/img/feedback-thumb.jpg")
          }
        }), _vm._v(" \n                                        " + _vm._s(instance.associated.name) + " (" + _vm._s(instance.associated.scheduledHours) + " hrs)\n                                        "), (instance.associated.coreCurriculum) ? _c('span', {
          attrs: {
            "title": "Core Curriculum Course"
          }
        }, [_c('i', {
          staticClass: "fa fa-star core-curriculum"
        })]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "position-wrapper"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (instance.position),
            expression: "instance.position"
          }],
          staticClass: "form-control",
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              instance.position = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            }, function($event) {
              _vm.updateInstance(instance, term.id)
            }]
          }
        }, _vm._l((15), function(i) {
          return _c('option', {
            key: i,
            domProps: {
              "value": i
            }
          }, [_vm._v(_vm._s(i))])
        }))])], 1)])
      })], 2)
    }))])]) : _vm._e()
  }), _vm._v(" "), (_vm.limitTerms === true) ? _c('div', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.limitTerms = false;
        _vm.getCourses()
      }
    }
  }, [_vm._v("Load All")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), ((
    _vm.localStorage.roles.includes('OnlineDirector') ||
    _vm.localStorage.roles.includes('Mentor') ||
    _vm.localStorage.roles.includes('Supervisor')) && _vm.groups) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'students' ? _vm.showPanel = null : _vm.showPanel = 'students'
      }
    }
  }, [_vm._v("Your Students\n                "), (_vm.showPanel === 'students') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanel === 'students'),
      expression: "showPanel==='students'"
    }],
    staticClass: "panel-body nopad"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v("View Your Students below:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group nopad groups"
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'groupStatistics',
          params: {
            groupId: group.id,
            groupLabel: group.label,
            term: group.groupTerm.id
          }
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm._f("capitalize")(group.groupTerm.type)) + " " + _vm._s(_vm._f("fullMonthAndYear")(group.groupTerm.startDate)) + " | " + _vm._s(group.label))])]), _vm._v(" "), _c('ul', {
      staticClass: "list-group"
    }, _vm._l((group.students), function(student) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'student',
            params: {
              studentId: student.populiId
            },
            query: {
              userId: student.id,
              term: group.groupTerm.id
            }
          }
        }
      }, [_vm._v("\n                                " + _vm._s(student.firstName) + " " + _vm._s(student.lastName) + "\n                            ")])], 1)
    }))], 1)
  }))])]) : _vm._e(), _vm._v(" "), (_vm.roles.includes('OnlineDirector') || _vm.roles.includes('CourseAdmin')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'trialCourses' ? _vm.showPanel = null : _vm.showPanel = 'trialCourses'
      }
    }
  }, [_vm._v("Trial Courses\n                "), (_vm.showPanel === 'trialCourses') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'trialCourses') ? _c('trial-courses') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'introVideos' ? _vm.showPanel = null : _vm.showPanel = 'introVideos'
      }
    }
  }, [_vm._v("Weekly Intro Videos\n                "), (_vm.showPanel === 'introVideos') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'introVideos') ? _c('intro-videos') : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.roles.includes('Supervisor') || _vm.roles.includes('Mentor')) && _vm.academicTerms) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'weeklyContent' ? _vm.showPanel = null : _vm.showPanel = 'weeklyContent'
      }
    }
  }, [_vm._v("Weekly Content\n                "), (_vm.showPanel === 'weeklyContent') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'weeklyContent') ? _c('supervisor-weekly-content', {
    attrs: {
      "courses": _vm.courses
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.roles.includes('Mentor') || _vm.roles.includes('Supervisor')) && _vm.academicTerms) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'journey' ? _vm.showPanel = null : _vm.showPanel = 'journey'
      }
    }
  }, [_vm._v("Journey (Your Student’s Important Milestones)\n                "), (_vm.showPanel === 'journey') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'journey') ? _c('supervisor-journey') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('CourseAdmin') || _vm.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'watermarkedFiles' ? _vm.showPanel = null : _vm.showPanel = 'watermarkedFiles'
      }
    }
  }, [_vm._v("Watermarked Assets\n                "), (_vm.showPanel === 'watermarkedFiles') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'watermarkedFiles') ? _c('watermarked-files') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'allIntroVideos' ? _vm.showPanel = null : _vm.showPanel = 'allIntroVideos'
      }
    }
  }, [_vm._v("Intro Videos (All)\n                "), (_vm.showPanel === 'allIntroVideos') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'allIntroVideos') ? _c('director-intro-videos') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'allMeetings' ? _vm.showPanel = null : _vm.showPanel = 'allMeetings'
      }
    }
  }, [_vm._v("Zoom Meetings\n                "), (_vm.showPanel === 'allMeetings') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'allMeetings') ? _c('director-meetings') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.showPanel === 'allFeedback' ? _vm.showPanel = null : _vm.showPanel = 'allFeedback'
      }
    }
  }, [_vm._v("Assignment Feedback\n                "), (_vm.showPanel === 'allFeedback') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showPanel === 'allFeedback') ? _c('director-feedback') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e79e24c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 2046
// module chunks = 2